@if(menu.isUser()){
  <div class="dock">
    <button>
      <i [routerLink]="router.get('collect-home')" routerLinkActive="dock-active" [routerLinkActiveOptions]="{ paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }" class="size-[1.2em] fa-regular fa-cards-blank"></i>
    </button>
    
    <div>
      <button class="btn btn-primary btn-gradient">
        <div class="icon-view">
          <div [ngStyle]="getSelectStyle()" class="icon-container">
              <i [routerLink]="router.get('collect-open-start')" class="add-item size-[1.5em] fa-regular fa-rectangle-vertical-history"></i>
              <i (click)="scanPage()" class="add-item size-[1.5em] fa-sharp fa-regular fa-grid-2-plus"></i>
              <i (click)="refreshCard()" routerLinkActive="dock-active" class="add-item size-[1.5em] fa-regular fa-arrows-rotate"></i>
            </div>
          </div>
      </button>
    </div>
    
    <button>
      <i [routerLink]="router.get('stat-home')" routerLinkActive="dock-active" [routerLinkActiveOptions]="{ paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }" class="size-[1.2em] fa-regular fa-chart-pie"></i>
    </button>
    
    <button>
      <i [routerLink]="router.get('shop')" routerLinkActive="dock-active" class="size-[1.2em] fa-regular fa-store"></i>
    </button>

    @if(canAdmin()){
      <!-- drawer -->
      <div class="drawer drawer-end">
        <input #drawer id="my-drawer-5" type="checkbox" class="drawer-toggle" />
        <label for="my-drawer-5">
          <i class="size-[1.2em] fa-regular fa-user-bounty-hunter"></i>
        </label>
        <div class="drawer-side">
          <label for="my-drawer-5" aria-label="close sidebar" class="drawer-overlay"></label>
          <ul class="admin-menu menu bg-base-200 min-h-full w-80 p-4">
            @if(userS.hasRight('users')){
              <li>
                <a (click)="drawer.checked=false" href="#" [routerLink]="router.get('admin-user-list')" routerLinkActive="menu-active">
                  <i class="fa-light fa-users"></i> Utilisateurs
                </a>
              </li>
            }
            @if(userS.hasRight('binders')){
              <li>
                <a href="#" [routerLink]="router.get('admin-binder')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                  <i class="fa-light fa-rectangle-vertical-history"></i> Binders
                </a>
              </li>
            }
            @if(userS.hasRight('cards') || userS.hasRight('scrap') || userS.hasRight('topK')){
              <li>
                <details open>
                  <summary>
                      <i class="fa-light fa-database"></i> Bibliothèque
                  </summary>
                  <ul>
                    @if(userS.hasRight('cards')){
                      <li>
                        <a href="#" [routerLink]="router.get('admin-card-list')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                          <i class="fa-light fa-cards-blank"></i> Cards
                        </a>
                      </li>
                    }
                    @if(userS.hasRight('scrap')){
                      <li>
                        <a href="#" [routerLink]="router.get('scrap-home')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                          <i class="fa-sharp fa-light fa-radar"></i> Scraping card tool
                        </a>
                      </li>
                    }
                    @if(userS.hasRight('topK')){
                      <li>
                        <a href="#" routerLinkActive="menu-active" (click)="drawer.checked=false">
                          <i class="fa-sharp fa-light fa-trophy-star"></i> TopK
                        </a>
                      </li>
                    }
                  </ul>
                </details>
              </li>
            }
            @if(userS.hasRight('prices')){
              <li>
                <details open>
                  <summary>
                      <i class="fa-light fa-circle-dollar"></i> Prices
                  </summary>
                  <ul>
                      <li>
                        <a href="#" [routerLink]="router.get('admin-card-list')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                          <i class="fa-light fa-bags-shopping"></i> Marketplaces
                        </a>
                      </li>
                      <li>
                        <a href="#" [routerLink]="router.get('proxies-list')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                          <i class="fa-light fa-chart-network"></i> Proxies
                        </a>
                      </li>
                  </ul>
                </details>
              </li>
            }
            @if(userS.hasRight('api')){
              <li>
                <a href="#" [routerLink]="router.get('api-key-list')" routerLinkActive="menu-active" (click)="drawer.checked=false">
                  <i class="fa-light fa-unlock-keyhole"></i> Api Key
                </a>
              </li>
            }
            @if(userS.hasRight('dashboard')){
              <li>
                <a href="#" routerLinkActive="menu-active" (click)="drawer.checked=false">
                  <i class="fa-light fa-gauge-high"></i> Dashboard
                </a>
              </li>
            }
          </ul>
          <div class="version">
          {{globalS.getVersion()}}
          </div>
        </div>
      </div>
    }
  </div>
} @else if(menu.isAdmin()){
  <div class="dock">
    <button>
      <svg class="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor" stroke-linejoin="miter" stroke-linecap="butt"><polyline points="1 11 12 2 23 11" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"></polyline><path d="m5,13v7c0,1.105.895,2,2,2h10c1.105,0,2-.895,2-2v-7" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path><line x1="12" y1="22" x2="12" y2="18" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></line></g></svg>
    </button>
    
    <button class="dock-active">
      <svg class="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor" stroke-linejoin="miter" stroke-linecap="butt"><polyline points="3 14 9 14 9 17 15 17 15 14 21 14" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"></polyline><rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></rect></g></svg>
    </button>
    
    <button>
      <svg class="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor" stroke-linejoin="miter" stroke-linecap="butt"><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></circle><path d="m22,13.25v-2.5l-2.318-.966c-.167-.581-.395-1.135-.682-1.654l.954-2.318-1.768-1.768-2.318.954c-.518-.287-1.073-.515-1.654-.682l-.966-2.318h-2.5l-.966,2.318c-.581.167-1.135.395-1.654.682l-2.318-.954-1.768,1.768.954,2.318c-.287.518-.515,1.073-.682,1.654l-2.318.966v2.5l2.318.966c.167.581.395,1.135.682,1.654l-.954,2.318,1.768,1.768,2.318-.954c.518.287,1.073.515,1.654.682l.966,2.318h2.5l.966-2.318c.581-.167,1.135-.395,1.654-.682l2.318.954,1.768-1.768-.954-2.318c.287-.518.515-1.073.682-1.654l2.318-.966Z" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path></g></svg>
    </button>
  </div>
}